import { useContext } from 'react';

import { ChecklistContext } from '@features/Checklist/model/context';

export const useChecklistContext = () => {
    const context = useContext(ChecklistContext);

    if (!context) {
        throw new Error('useChecklistContext must be used within ChecklistContext.Provider');
    }

    return context;
};
